import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Collapse, CollapseProps, Modal, Table } from 'antd';
import { NameOf } from 'src/utils';
import { ColumnProps } from 'antd/lib/table';
import TableColumnBuilder from 'src/utils/core/TableColumnBuilder';
import { FilterValue } from 'antd/lib/table/interface';
import LicenseListItemDTO from 'src/models/generated/LicenseListItemDTO';

export interface LicensesTableProps {
  data?: LicenseListItemDTO[];
  loading?: boolean;
}

const LicensesTable: React.FC<LicensesTableProps> = (props) => {
  const [filteredInfo, setFilteredInfo] = useState<Record<string, FilterValue | null>>({});
  const [openKeys, setOpenKeys] = useState<Parameters<Required<CollapseProps>['onChange']>[0]>(['1']);
  const tableData = props.data ?? [];

  useEffect(() => {
    if (props.loading) {
      setFilteredInfo({});
    }
  }, [props.loading]);

  const showModal = (record: LicenseListItemDTO) => {
    Modal.info({
      icon: null,
      content: <div dangerouslySetInnerHTML={{ __html: record.details }}></div>
    });
  };
  const tableColumns: ColumnProps<LicenseListItemDTO>[] = [
    TableColumnBuilder.Create<LicenseListItemDTO>('licenseNumber', 'License Number')
      .Width(350)
      .AddSorter('Text')
      .AddTextFilterer()
      .AddRenderer('Typography', { copyable: true, ellipsis: true })
      .DefaultSortOrder('ascend')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<LicenseListItemDTO>('pos', 'POS')
      .Width(100)
      .AddSorter('Text')
      .AddTextFilterer()
      .AddRenderer('Ellipses')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<LicenseListItemDTO>('sms', 'SMS')
      .Width(100)
      .AddSorter('Text')
      .AddTextFilterer()
      .AddRenderer('Ellipses')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<LicenseListItemDTO>('asset', 'Asset')
      // .Width(400)
      .AddSorter('Text')
      .AddTextFilterer()
      .AddRenderer('Ellipses')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<LicenseListItemDTO>('product', 'Product')
      .Width(200)
      .AddSorter('Text')
      .AddTextFilterer()
      .AddRenderer('Ellipses')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<LicenseListItemDTO>('location', 'Location')
      .Width(300)
      .AddSorter('Text')
      .AddTextFilterer()
      .AddRenderer('Typography', { copyable: true, ellipsis: true })
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<LicenseListItemDTO>('activatedDate', 'Activated Date')
      .Width(150)
      .AddSorter('Date')
      .AddEnumFilterer(tableData.map(x => x.activatedDate).filter(x => x != null && x?.year() > 2000).map(x => x?.format('L') ?? ''), 'Date')
      .AddRenderer('ShortDate', false)
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<LicenseListItemDTO>('activated', 'Activated')
      .Width(100)
      .Align('center')
      .AddRenderer('Custom', (val) => <Checkbox disabled checked={val}></Checkbox>)
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<LicenseListItemDTO>('disabled', 'Disabled')
      .Width(100)
      .Align('center')
      .AddRenderer('Custom', (val) => <Checkbox disabled checked={val}></Checkbox>)
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<LicenseListItemDTO>('details')
      .Width(125)
      .AddRenderer('Custom', (value, record) => <Button type='link' onClick={() => showModal(record)}>View Details</Button>)
      .FilteredValue(filteredInfo)
      .Build(),
  ];

  return <div className='contacts-table table-section'>
    <Collapse ghost collapsible='header' activeKey={openKeys} onChange={setOpenKeys}>
      <Collapse.Panel key={1} header={<h3 className='table-title'>Licenses</h3>}>
        <Table
          rowKey={NameOf<LicenseListItemDTO>('id')}
          className='condensed-table striped-table borderless-table'
          rowClassName={(record, index) => (index % 2 ? 'striped-row' : '')}
          loading={props.loading}
          pagination={false}
          columns={tableColumns}
          dataSource={tableData}
          onChange={(_, filters) => { setFilteredInfo(filters); }}
        />
      </Collapse.Panel>
    </Collapse>
  </div>;
};

export default LicensesTable;
